import React, { useState, useEffect } from "react";
import DashboardManager from "./manager/dashboard";

const Dashboard = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isRole, setIsRole] = useState('false');
  useEffect(() => {
    const authState = localStorage.getItem("authToken");
    if (authState) {
      setIsLoggedIn(true);
      const role = localStorage.getItem("role");
      if (role) {
        setIsRole(role);
      }
    }
  }, []);

  return (
    <>
      <DashboardManager /> 
    </>
  );
};
export default Dashboard;